import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import {
  RequestAction,
  RequestFailure,
  RequestSuccess,
} from '../../RequestAction';
import {
  RequestUserFavoriteUnitsSuccess,
  RequestUserFavoriteUnitSuccess,
} from './response';
import { ApiClient } from '@Api';
import { UserFavoriteUnitMapper } from '@Mapper/ninthAge/user-favorite/unit.mapper';
import { Locale } from '@Repository/locale';
import { UserFavoriteUnit } from '@Models';

@injectable()
export class UserFavoriteUnitRepository {
  @inject(TYPES.Locale) protected _locale!: Locale;
  @inject(TYPES.Mapper.UserFavorite.Unit)
  private _unitMapper!: UserFavoriteUnitMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;

  public async getAll(
    armyId: number,
    {
      locale,
    }: {
      locale?: string | null;
    } = {},
  ): Promise<RequestAction> {
    try {
      const datas = await this._apiClient.ninthAge.getAllUserFavoriteUnits({
        armyId: armyId,
        locale: locale ?? this._locale.getlocale(),
      });
      return new RequestUserFavoriteUnitsSuccess({
        payload: datas.map((item) => this._unitMapper.map(item)),
      });
    } catch (error: any) {
      console.log('error', error);
      return new RequestFailure({ error: error });
    }
  }

  public async create(
    favoriteUnit: UserFavoriteUnit,
    {
      locale,
    }: {
      locale?: string | null;
    } = {},
  ): Promise<RequestAction> {
    try {
      const bodyDto = this._unitMapper.mapDto(favoriteUnit);

      const arsenalUnitDto =
        await this._apiClient.ninthAge.createUserFavoriteUnit({
          locale: locale ?? this._locale.getlocale(),
          requestBody: bodyDto,
        });
      return new RequestUserFavoriteUnitSuccess({
        payload: this._unitMapper.map(arsenalUnitDto),
      });
    } catch (error: any) {
      return new RequestFailure({ error: error });
    }
  }

  public async delete(
    unitId: string,
    {
      locale,
    }: {
      locale?: string | null;
    } = {},
  ): Promise<RequestAction> {
    try {
      await this._apiClient.ninthAge.deleteUserFavoriteUnit({
        locale: locale ?? this._locale.getlocale(),
        favoriteUnitId: unitId,
      });
      return new RequestSuccess();
    } catch (error: any) {
      return new RequestFailure({ error: error });
    }
  }
}
